// Regras da prévia do Studio sem dependência de Vue nem do navegador
// (testadas em tests/previaStudioNucleo.test.mjs).
// O token chega no fragmento da URL (#previaStudio=...), que o navegador não envia ao servidor.

export const CABECALHO = 'X-Clic-Previa';
const MARCADOR = 'previaStudio=';
const DOMINIO = '.clictecnologia.com.br';

export const lerTokenDaUrl = (hash) => {
  const texto = String(hash || '').replace(/^#/, '');
  const parte = texto.split('&').find((trecho) => trecho.startsWith(MARCADOR));
  const token = parte ? decodeURIComponent(parte.slice(MARCADOR.length)) : '';
  return token || null;
};

export const hashSemToken = (hash) => {
  const restantes = String(hash || '')
    .replace(/^#/, '')
    .split('&')
    .filter((trecho) => trecho && !trecho.startsWith(MARCADOR));
  return restantes.length ? `#${restantes.join('&')}` : '';
};

const base64UrlParaTexto = (texto) => {
  const base64 = texto.replace(/-/g, '+').replace(/_/g, '/');
  const completo = base64 + '='.repeat((4 - (base64.length % 4)) % 4);
  const binario = atob(completo);
  const bytes = Uint8Array.from(binario, (letra) => letra.charCodeAt(0));
  return new TextDecoder().decode(bytes);
};

// Só lê o conteúdo para a tela (quem confere a assinatura é o backend)
export const lerDadosDoToken = (token) => {
  try {
    const partes = String(token || '').split('.');
    if (partes.length !== 3) return null;
    const dados = JSON.parse(base64UrlParaTexto(partes[1]));
    if (dados.tipo !== 'previa-studio' || !dados.subdominio || typeof dados.exp !== 'number') return null;
    return dados;
  } catch (erro) {
    return null;
  }
};

// 'ativa' | 'expirada' | 'outroTenant' | 'invalida'
export const situacaoDoToken = (token, { subdominio, agoraMs }) => {
  const dados = lerDadosDoToken(token);
  if (!dados) return 'invalida';
  if (dados.subdominio !== subdominio) return 'outroTenant';
  if (dados.exp * 1000 <= agoraMs) return 'expirada';
  return 'ativa';
};

// O cabeçalho só vai para o endereço do próprio tenant: nunca para o admfw, outros tenants
// ou serviços de fora
export const deveEnviarCabecalho = ({ url, baseURL, origem }, subdominio) => {
  try {
    const destino = new URL(url, baseURL || origem);
    return destino.host === `${subdominio}${DOMINIO}` || (!baseURL && destino.origin === origem);
  } catch (erro) {
    return false;
  }
};

export const ehErroDePrevia = (erro) => {
  const resposta = erro && erro.response;
  if (!resposta || resposta.status !== 409) return false;
  return Boolean(resposta.data && resposta.data.previaInvalida);
};
